<script setup lang="ts">

import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore.ts'
import { formatNumber } from '@/models/formatNumber.ts'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const number = computed(() => {
  return gameStore.player?.credits??0
});


</script>

<template>
  <StandardCard :title="t('government.finances.balance')" top-padding="0">
    <div class="flex justify-center rounded py-5 sunken">
      <span :class="{
        'balance': true,
        'text-green-500': number >= 0,
        'text-red-500': number < 0
      }">{{ formatNumber(number) }}</span>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">
  .balance {
    font-size: 2rem;
    font-weight: 600;
  }

  .sunken {
    background: rgba(15, 18, 22, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
  }
</style>